import React, { useEffect, useState } from "react";
// import "primereact/resources/themes/tailwind-light/theme.css";
// import "primereact/resources/primereact.min.css";
// import "primeicons/primeicons.css";
import configuationManagementService from "@services/configuationManagement.service";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';


export default function TiltInAtolandConfig() {
  const [availableDates, SetAvailableDates] = useState(null);
  const [data, setData] = useState([{ name: "Select a date ......" }]);
  const [date, setdate] = useState([]);
  const [blocked, setBlocked] = useState(false);


  useEffect(() => {
    let isMounted = true;

    configuationManagementService.RetAvailableDate().then((result) => {
      SetAvailableDates(result.data);
    });
    return () => { isMounted = false };
  }, []);
  const onClick = () => {
    setBlocked(true);
    configuationManagementService.Post("/irancell/ret/toCell", { date: date }).then((result) => {
      setData(result.data);
      setBlocked(false);
    }).catch((err) => {
      setBlocked(false);
      setData([{ name: err.message }])
    });
  };
  const exportExcel = () => {
    import('xlsx').then((xlsx) => {
      const workbook = xlsx.utils.book_new();

      const worksheet = xlsx.utils.json_to_sheet(data);
      xlsx.utils.book_append_sheet(workbook, worksheet, "data");


      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      saveAsExcelFile(excelBuffer, "RET-Compare");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import('file-saver').then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
          type: EXCEL_TYPE
        });

        module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      }
    });
  };



  const header = (
    <div className="flex align-items-center justify-content-end gap-2">
      <Dropdown value={date} required options={availableDates} onChange={(e) => setdate(e.value)}
        placeholder="Select  Date" className="w-full md:w-14rem" />

      <div className="p-inputgroup"><Button label="Submit" onClick={onClick} /></div>

      <div className="p-inputgroup"><Button type="button" icon="pi pi-file-excel" severity="success" rounded raised data-pr-tooltip="XLS" onClick={exportExcel} /></div>
    </div>
  );
  return (

    // <Panel header="Header">
    //   <p className="m-0">
    //     Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
    //     Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
    //     consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
    //     Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    //   </p>
    // </Panel>
    <div>
      {/* <div className="card m-0">
        <Toolbar start={startContent} />
      </div> */}
      <div className="card">
        <DataTable loading={blocked} paginator rows={20} rowsPerPageOptions={[20, 50, 100]} sortMode="multiple" size="small" value={data} header={header} tableStyle={{ minWidth: '50rem' }}>
          {Object.keys(data[0]).map((col, i) => (
            // console.log(col)
            <Column key={col} sortable field={col} header={col} />
          ))}
        </DataTable>
      </div>
    </div>
  );
}






